import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Autocomplete,
  CircularProgress,
  Backdrop,
  TextField,
  Stack,
  Divider,
  Container,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import moment from 'moment';
import SaveIcon from '@material-ui/icons/Save';
import Controls from '../controls/Controls';
import { useSettingContext } from '../../context/setting_context';
import { baseUrl, paymentJournals } from '../../utils/constants';

export default function PayBill() {
  const navigate = useNavigate();
  const { payCycles } = useSettingContext();
  const [formData, setFormData] = useState({
    accountRefId: '',
    paymentDate: '',
    receipient: '',
    supplierInvNo: 'none',
    subAmount: 0,
    vatPaid: 0,
    amountPaid: 0,
    paymentMethod: 807100,
    paymentDetails: '',
    authorizedBy: 0,
    payDocNo: '',
    created: false,
    processed: false,
    userRefId: 0,
    cycleRefId: 0,
    claimId: 0
  });
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [revenues, setRevenues] = useState([]);
  const [expenses, setExpenses] = useState([]);

  const PaymentsSchema = Yup.object().shape({
    accountRefId: Yup.number().required('Please select Account, field is Required'),
    paymentDate: Yup.date().required('Please select Payment Date, field is Required'),
    amountPaid: Yup.string()
      .min(2, 'Amount Paid should be greater than 2')
      .required('Amount Paid is required'),
    paymentMethod: Yup.string().required('Method of Payment is required'),
    receipient: Yup.string()
      .min(2, 'Entity Paid is too Short!')
      .max(50, 'Entity Paid is too Long!')
      .required('Entity Paid is required'),
    paymentDetails: Yup.string()
      .min(2, 'Details of Payment is too Short!')
      .max(50, 'Details of Payment is too Long!')
      .required('Details of Payment is required'),
    cycleRefId: Yup.number().min(1).required('Please select Cycle, field is Required')
  });

  const formik = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema: PaymentsSchema,
    onSubmit: (values) => {
      console.log('values paybill', values);
      savePayments(values);
    }
  });

  useEffect(() => {
    populateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const savePayments = (e) => {
    const jsonClient = [];
    jsonClient.push(e);
    console.log('expenditure stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/accounting/SaveExpenditure`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setFormData(result);
          console.log('returned Payments', result);
          setLoading(false);
          notifyPopup(`Payment Updated Successfully!`, 'success');
          navigate(-1);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving Payment!: ${error}`, 'error');
        }
      );
  };

  const getRevenueAccounts = async (accountType) => {
    await axios(`${baseUrl}/api/accounting/GetAccountsByType?accountType=6`).then(
      (result) => {
        console.log('returned getRevenueAccounts info', result);
        setRevenues(result.data.result);
      },
      (error) => {
        notifyPopup(`Error in getting revenue!: ${error}`, 'error');
      }
    );
  };

  const getExpenseAccounts = async () => {
    setLoading(true);
    await axios(`${baseUrl}/api/accounting/GetAccountsByType?accountType=3`).then(
      (result) => {
        console.log('returned getRevenueAccounts info', result);
        setExpenses(result.data.result);
        setLoading(false);
      },
      (error) => {
        notifyPopup(`Error in getting revenue!: ${error}`, 'error');
        setLoading(false);
      }
    );
  };

  const populateList = async () => {
    setLoading(true);
    await axios(`${baseUrl}/api/claims/GetClaimsByStatus?status=5`).then(
      (result) => {
        console.log('returned GetClaimsByStatus', result);
        setList(result.data.result);
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        notifyPopup(`Error in getting students!: ${error}`, 'error');
      }
    );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const defprops = {
    options: list,
    // key: list.claim_ID,
    getOptionLabel: (options) => `${options.claim_ID} ${options.patientName} ${options.awardTotal}`
  };

  const { errors, touched } = formik;

  return (
    <Container>
      <Typography component="span" variant="h4" gutterBottom>
        Payment
      </Typography>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography variant="h6" color="error">
                Process Single Payment
              </Typography>
              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={8}>
                  <Autocomplete
                    {...defprops}
                    id="accountRefIds"
                    onChange={(e, value) => {
                      console.log('now selecte', value);
                      console.log('now e', e);
                      formik.setFieldValue('accountRefId', value.cif_Number);
                      formik.setFieldValue('amountPaid', value.awardTotal);
                      formik.setFieldValue('receipient', value.patientName);
                      formik.setFieldValue('claimId', value.claim_ID);
                      formik.setFieldValue('userRefId', sessionStorage.getItem('userRefId'));
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Pay to..." variant="standard" />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Controls.Input name="accountRefId" label="Account Ref#" disabled />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="receipient" label="Paid to" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.DateTime name="paymentDate" label="Payment Date" />
                </Grid>

                <Stack
                  direction="column"
                  spacing={2}
                  justifyContent="space-between"
                  sx={{ minWidth: 0 }}
                  mb={2}
                  mt={2}
                >
                  <Grid item xs={12} sm={12} justifyContent="center" alignItems="center">
                    <Controls.Input name="amountPaid" label="Amount Paid" />
                  </Grid>
                </Stack>
                <Divider
                  style={{ background: '#00000', height: 0, margin: 2, mt: 2, width: '90%' }}
                  variant="middle"
                />
                <Grid item xs={12} sm={6}>
                  <Controls.SelectJson
                    name="paymentMethod"
                    label="Payment Method"
                    options={paymentJournals}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="claimId" label="Claim #" disabled />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="paymentDetails" label="Details..." />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="revLabel">Pay Cycle</InputLabel>
                    <Select
                      id="cycleRefId"
                      value={formik.values.cycleRefId}
                      name="cycleRefId"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('cycleRefId', e.target.value);
                      }}
                      helperText={touched.cycleRefId ? errors.cycleRefId : ''}
                      error={touched.cycleRefId && Boolean(errors.cycleRefId)}
                    >
                      <MenuItem key="" value="0">
                        Not Selected
                      </MenuItem>
                      {payCycles.map((item) => (
                        <MenuItem key={item.payCycleId} value={item.payCycleId}>
                          {moment(item.payDate).format('MMM YYYY')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  margin={2}
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="right"
                >
                  <Grid item xs={12} sm={6}>
                    <Controls.CheckBox name="processed" label="Processed" disabled />
                  </Grid>
                  <Grid item xs={12} sm={1} marginRight={1}>
                    <Controls.Button type="submit" variant="contained" startIcon={<SaveIcon />}>
                      Save...
                    </Controls.Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </CardContent>
      </Card>
    </Container>
  );
}
